import { Column, Entity, PrimaryGeneratedColumn } from 'typeorm';
import { BaseEntity } from './BaseEntity';
import { IRefSurveillanceTypology } from './interface/IRefSurveillanceTypology';

@Entity('ref_surveillance_typology')
export class RefSurveillanceTypology extends BaseEntity implements IRefSurveillanceTypology{
  apiMapping = {
      id: 'id',
      name: 'name',
  };

  @PrimaryGeneratedColumn()
  id: number;

  @Column()
  name: string;

  @Column({ nullable: true })
  isDeleted: boolean;
}
